const stub = false;

const uids = [];

export const isStub = (uid) => {
  if (!stub) return false;

  return typeof uid !== 'string' ? 'exeption' : !uids.includes(uid);
};
